'use client'

import type { HeadingSize, ThemeTextColor } from '@mntn-dev/ui-theme'
import { Heading } from '../../heading/heading.tsx'
import { usePageHeaderContext } from './use-page-header.ts'
import type { PageHeaderSize } from './use-page-header.ts'

export type PageHeaderTitleProps = {
  title: string
  textColor?: ThemeTextColor
}

const sizeMap: Record<PageHeaderSize, HeadingSize> = {
  sm: 'xl',
  md: '2xl',
  lg: '4xl',
}

export const PageHeaderTitle = ({ title, textColor }: PageHeaderTitleProps) => {
  const { dataTestId, dataTrackingId, size } = usePageHeaderContext()
  return (
    <Heading
      fontSize={sizeMap[size]}
      fontWeight="bold"
      textColor={textColor || 'primary'}
      dataTestId={`${dataTestId}-title`}
      dataTrackingId={`${dataTrackingId}-title`}
      className="header-title"
    >
      {title}
    </Heading>
  )
}
